<template>
  <section class="table-sampler-result-noise table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="bg-grey text-left" style="width:15%;">Campo</th>
          <th class="text-center" style="width:42.5%">NHO 01</th>
          <th class="text-center" style="width:42.5%">NR 15</th>
        </tr>
      </thead>
      <tbody>
        <!-- Código -->
        <tr>
          <td class="bg-grey">Código</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.code" placeholder="Código NHO 01" disabled />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.code" placeholder="Código NR 15" disabled />
          </td>
        </tr>
        <!-- Agente -->
        <tr>
          <td class="bg-grey">Agente</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.agent" placeholder="Agente NHO 01" disabled />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.agent" placeholder="Agente NR 15" disabled />
          </td>
        </tr>
        <!-- Método -->
        <tr>
          <td class="bg-grey">Método</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.method" placeholder="Método NHO 01" disabled />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.method" placeholder="Método NR 15" disabled />
          </td>
        </tr>
        <!-- Resultado -->
        <tr>
          <td class="bg-grey">Resultado</td>
          <td>
            <input type="number" class="form-control" v-model="model.nho.result" placeholder="Resultado NHO 01"  @input="setAttenuationResult('nho')" />
          </td>
          <td>
            <input type="number" class="form-control" v-model="model.nr15.result" placeholder="Resultado NR 15" @input="setAttenuationResult('nr15')" />
          </td>
        </tr>
        <!-- Atenuação -->
        <tr>
          <td class="bg-grey">Atenuação</td>
          <td>
            <input type="number" class="form-control" v-model="model.nho.attenuation" placeholder="Atenuação NHO 01" @input="updateRelatedData('nho')" />
          </td>
          <td>
            <input type="number" class="form-control" v-model="model.nr15.attenuation" placeholder="Atenuação NR 15" @input="updateRelatedData('nr15')" />
          </td>
        </tr>
        <!-- Resultado Atenuante -->
        <tr>
          <td class="bg-grey">
            Resultado Atenuante
            <i class="fas fa-info-circle p-0 fa-xs" id="tooltip-attenuation_result" style="cursor:pointer" />
            <d-tooltip target="#tooltip-attenuation_result" placement="top">
              Calculado automaticamente: Resultado - Atenuação
            </d-tooltip>
          </td>
          <td>
            <input type="number" class="form-control" v-model="model.nho.attenuation_result" placeholder="Resultado Atenuante NHO 01" />
          </td>
          <td>
            <input type="number" class="form-control" v-model="model.nr15.attenuation_result" placeholder="Resultado Atenuante NR 15" />
          </td>
        </tr>
        <!-- LAVG -->
        <tr>
          <td class="bg-grey">LAVG</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.lavg" placeholder="LAVG NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.lavg" placeholder="LAVG NR 15" />
          </td>
        </tr>
        <!-- LEQ -->
        <tr>
          <td class="bg-grey">LEQ</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.leq" placeholder="LEQ NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.leq" placeholder="LEQ NR 15" />
          </td>
        </tr>
        <!-- TWA -->
        <tr>
          <td class="bg-grey">TWA</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.twa" placeholder="TWA NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.twa" placeholder="TWA NR 15" />
          </td>
        </tr>
        <!-- NEN -->
        <tr>
          <td class="bg-grey">NEN</td>
          <td>
            <input type="text" class="form-control" v-model="model.nho.nen" placeholder="NEN NHO 01" />
          </td>
          <td>
            <input type="text" class="form-control" v-model="model.nr15.nen" placeholder="NEN NR 15" />
          </td>
        </tr>
        <!-- Dose -->
        <tr>
          <td class="bg-grey">Dose 8h</td>
          <td>
            <input type="number" min="0" @input="handleDoseChange('nho', 'dose8')" class="form-control" v-model="model.nho.dose8" placeholder="Dose 8h NHO 01" />
          </td>
          <td>
            <input type="number" min="0" @input="handleDoseChange('nr15', 'dose8')" class="form-control" v-model="model.nr15.dose8" placeholder="Dose 8h NR 15" />
          </td>
        </tr>
        <!-- Dose Atenuante -->
        <tr>
          <td class="bg-grey">
            Dose 8h Atenuante
            <i class="fas fa-info-circle p-0 fa-xs" id="tooltip-attenuated_dose8" style="cursor:pointer" />
            <d-tooltip target="#tooltip-attenuated_dose8" placement="top">
              Calculado automaticamente: Dose 8h - Atenuação
            </d-tooltip>
          </td>
          <td>
            <input type="number" min="0" @input="handleDoseChange('nho', 'attenuated_dose8')" class="form-control" v-model="model.nho.attenuated_dose8" placeholder="Dose 8h Atenuante NHO 01" />
          </td>
          <td>
            <input type="number" min="0" @input="handleDoseChange('nr15', 'attenuated_dose8')" class="form-control" v-model="model.nr15.attenuated_dose8" placeholder="Dose 8h Atenuante NR 15" />
          </td>
        </tr>
        <!-- Conclusão -->
        <tr>
          <td class="bg-grey">
            Conclusão
            <i class="fas fa-info-circle p-0 fa-xs" id="tooltip-conclusao-noise" style="cursor:pointer" />
            <d-tooltip target="#tooltip-conclusao-noise" placement="top">
              Este campo é preenchido automaticamente com base na Dose 8h, conforme as regras definidas em: Configurações / Resultados / Resultados Ruído.
            </d-tooltip>
          </td>
          <td>
            <textarea rows="2" style="resize:vertical" type="text" class="form-control" v-model="model.nho.conclusion" placeholder="Conclusão NHO 01" disabled />
          </td>
          <td>
            <textarea rows="2" style="resize:vertical" type="text" class="form-control" v-model="model.nr15.conclusion" placeholder="Conclusão NR 15" disabled />
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { mapActions } from 'vuex';
import { NOISE } from '_modules/settings/components/SettingsModel';
import { NOISE_RESULT,
  _ADD_ATTENUATED_DOSE_8_TAB_CLASSIFICATION_NOISE_,
  _ADD_CONCLUSION_TAB_CLASSIFICATION_NOISE_,
  _ADD_SAMPLE_AGENT_TAB_RESULT_NOISE_,
  _UPDATE_SAMPLE_ATTENUATION_NOISE_,
  _LOAD_MODEL_,
  _RELOAD_SAMPLE_AGENT_ } from '../../SampleModel';

export default {
  name: 'Sample-Result-Noise',
  props: {
    result: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(NOISE_RESULT),
    };
  },
  computed: {
    noiseSettings() {
      const { noise } = this.$store.state.settings.results;
      if (noise) {
        return noise;
      }
      return { ...NOISE };
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getSettings',
    ]),
    handleLoadModel() {
      this.setModel();
    },
    setModel() {
      if (this.result) {
        const newModel = cloneDeep(this.model);

        if (this.result.nho) newModel.nho = { ...newModel.nho, ...this.result.nho };
        if (this.result.nr15) newModel.nr15 = { ...newModel.nr15, ...this.result.nr15 };

        this.model = newModel;
      }
    },
    handleDoseChange(type, field) {
      const value = this.model[type][field];

      if (field === 'dose8') {
        this.setConclusion(value, type);
      }

      if (field === 'attenuated_dose8') {
        Events.$emit(_ADD_ATTENUATED_DOSE_8_TAB_CLASSIFICATION_NOISE_, { value, type });
      }
    },
    setConclusion(dose8, type) {
      const numberRegex = /[-+]?\d{1,3}(?:,\d{3})*(?:\.\d+)?|\d+(\.\d+)?/g;

      this.setAttenuationDose(type);

      if (!dose8 || !numberRegex.test(dose8)) {
        this.model[type].conclusion = null;
        this.model[type].bgColor = '#cfcfc4';

        Events.$emit(_ADD_CONCLUSION_TAB_CLASSIFICATION_NOISE_, {
          type,
          technicalConsiderations: null,
          recommendedAction: null,
          dose: null,
        });
        return;
      }

      const levels = Object.entries(this.noiseSettings[type]);
      const matchingEntry = this.findLevelMatch(dose8, levels);

      if (matchingEntry) {
        const [matchingKey, matchingLevel] = matchingEntry;
        this.model[type].conclusion = matchingLevel ? matchingLevel.technicalConsiderations : null;
        this.model[type].bgColor = this.noiseSettings[type][matchingKey].bgColor || '#cfcfc4';

        Events.$emit(_ADD_CONCLUSION_TAB_CLASSIFICATION_NOISE_, {
          type,
          dose: dose8,
          technicalConsiderations: matchingLevel.technicalConsiderations,
          recommendedAction: matchingLevel.recommendedAction,
          bgColor: matchingLevel.bgColor,
        });
      }
    },
    findLevelMatch(dose8, levels) {
      const doseValue = this.convertToNumber(dose8);

      return levels.find(level => {
        const min = level[1].dailyDoseMin ? this.convertToNumber(level[1].dailyDoseMin) : -Infinity;
        const max = level[1].dailyDoseMax ? this.convertToNumber(level[1].dailyDoseMax) : Infinity;
        return doseValue >= min && doseValue < max;
      });
    },
    convertToNumber(value) {
      if (value) {
        const number = parseFloat(value.toString().replace(/,/g, '.'));
        if (!Number.isNaN(number) && number !== 0) {
          return number;
        }
      }
      return null;
    },
    setAgentData(agent) {
      this.model.nho.agent = agent?.name || null;
      this.model.nho.method = agent?.method || null;
      this.model.nho.code = agent?.code || null;
      this.model.nr15.agent = agent?.name || null;
      this.model.nr15.method = agent?.method_nr15 || null;
      this.model.nr15.code = agent?.code_nr15 || null;
    },
    setAttenuationResult(type) {
      const originalResult = this.model[type].result || 0;
      const attenuation = this.model[type].attenuation || 0;
      const finalValue = parseFloat(originalResult) - parseFloat(attenuation);

      this.model[type].attenuation_result = finalValue;
    },
    setAttenuationDose(type) {
      const dose8 = this.model[type].dose8 || 0;
      const attenuation = this.model[type].attenuation || 0;
      const finalValue = parseFloat(dose8) - parseFloat(attenuation);

      this.model[type].attenuated_dose8 = finalValue;
    },
    updateRelatedData(type) {
      this.setAttenuationResult(type);
      this.setAttenuationDose(type);
    },
    handleReloadSampleAgent(agent) {
      this.setAgentData(agent);
    },
    handleAddSampleAgent(agent) {
      this.setAgentData(agent);
      this.activeAlert({
        message: 'Agente atualizado na aba Resultado.',
        theme: 'success',
      });
    },
    handleSetAttenuation(attenuation) {
      this.model.nho.attenuation = attenuation;
      this.model.nr15.attenuation = attenuation;

      this.updateRelatedData('nho');
      this.updateRelatedData('nr15');

      this.activeAlert({
        message: 'Atenuação atualizada na aba Resultado.',
        theme: 'success',
      });
    },
  },
  mounted() {
    this.getSettings()
      .then(() => this.setModel());
    Events.$on(_LOAD_MODEL_, this.handleLoadModel);
    Events.$on(_ADD_SAMPLE_AGENT_TAB_RESULT_NOISE_, this.handleAddSampleAgent);
    Events.$on(_RELOAD_SAMPLE_AGENT_, this.handleReloadSampleAgent);
    Events.$on(_UPDATE_SAMPLE_ATTENUATION_NOISE_, this.handleSetAttenuation);
  },
  beforeDestroy() {
    Events.$off(_LOAD_MODEL_, this.handleLoadModel);
    Events.$off(_ADD_SAMPLE_AGENT_TAB_RESULT_NOISE_, this.handleAddSampleAgent);
    Events.$off(_RELOAD_SAMPLE_AGENT_, this.handleReloadSampleAgent);
    Events.$off(_UPDATE_SAMPLE_ATTENUATION_NOISE_, this.handleSetAttenuation);
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:result', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
td {
  vertical-align: middle;
}

input {
  min-width: 150px;
}

</style>
